import { DataKeys } from "../../types";
import { getLocalized, HealthLang } from "./healthTypes";
import {
    healthLifecycleSelectorActive,
    healthLifecycleSelectorBase,
    healthLifecycleSelectorDot,
    healthLifecycleSelectorDotActive,
    healthLifecycleSelectorDotInactive,
    healthLifecycleSelectorInactive,
    healthLifecycleSelectorLabel,
    healthLifecycleSelectorTitle,
    healthFocusVisible,
} from "./healthVisualStyles";

interface HealthLifecycleStageSelectorProps {
    stage: DataKeys;
    isActive: boolean;
    onSelect: () => void;
    lang: HealthLang;
}

/** Reference row: dot on rail + small number + title (no pills/cards) */
export function HealthLifecycleStageSelector({
    stage,
    isActive,
    onSelect,
    lang,
}: HealthLifecycleStageSelectorProps) {
    const stepLabel = getLocalized(stage?.label, lang);
    const stepTitle = getLocalized(stage?.title, lang);

    return (
        <button
            type="button"
            onClick={onSelect}
            aria-current={isActive ? "step" : undefined}
            role="tab"
            aria-selected={isActive}
            className={`${healthLifecycleSelectorBase} ${healthFocusVisible} ${
                isActive
                    ? healthLifecycleSelectorActive
                    : healthLifecycleSelectorInactive
            }`}
        >
            <span
                className={`${healthLifecycleSelectorDot} ${
                    isActive
                        ? healthLifecycleSelectorDotActive
                        : healthLifecycleSelectorDotInactive
                }`}
                aria-hidden="true"
            />
            <div className={healthLifecycleSelectorLabel}>{stepLabel}</div>
            <div
                className={`${healthLifecycleSelectorTitle} ${
                    isActive ? "text-teal-500" : "text-grey-600"
                }`}
            >
                {stepTitle}
            </div>
        </button>
    );
}
